import { DynamicQuestionCode } from 'types/dynamicFields'
import { DynamicQuestionFieldTypes } from './constants'
import { DynamicQuestionMapping } from './types'

export const getAdditionalFieldKey = (key: DynamicQuestionCode) => `${key}Additional`
export const getContactLastNameFieldKey = (key: DynamicQuestionCode) => `${key}LastName`
export const getContactEmailFieldKey = (key: DynamicQuestionCode) => `${key}Email`

export const getFieldDefaultValue = (
  key: DynamicQuestionCode,
  question: DynamicQuestionMapping
): Record<string, string> => {
  const { type, additionalQuesion, savedAnswer } = question || {}
  switch (type) {
    case DynamicQuestionFieldTypes.RADIO:
      return {
        [key]: savedAnswer?.selected ?? null,
        ...(additionalQuesion && { [getAdditionalFieldKey(key)]: savedAnswer?.answer ?? '' }),
      }
    case DynamicQuestionFieldTypes.CONTACT:
      return {
        [key]: savedAnswer?.contact?.first_name ?? '',
        [getContactLastNameFieldKey(key)]: savedAnswer?.contact?.last_name ?? '',
        [getContactEmailFieldKey(key)]: savedAnswer?.contact?.email ?? '',
      }
    default:
      return { [key]: savedAnswer?.answer ?? '' }
  }
}
